import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { getSeccionesVisibles, getGruposVisibles } from '../../config/menuSections';
import useNotificacionesSistema from '../../hooks/useNotificacionesSistema';
import useNotificacionesWhatsApp from '../../hooks/useNotificacionesWhatsApp';
import useNotificacionesAnses from '../../hooks/useNotificacionesAnses';
import useNotificacionesCorreo from '../../hooks/useNotificacionesCorreo';
import MobileHeader from './MobileHeader';
import BottomNav from './BottomNav';
import DrawerMas from './DrawerMas';
import CampanaUnificada from './CampanaUnificada';

// Orquestador de la navegación mobile (header + bottom nav + overlays), análogo al Navegacion
// que exporta NavegacionLateral.js para desktop/tablet — MainLayout.js monta uno u otro según
// useBreakpoint(), nunca los dos a la vez (evita duplicar los pollers de notificación).
//
// Único punto que llama a los 4 hooks de notificación, para que el contador del header y la
// casilla de CampanaUnificada lean la misma fuente sin fetchear dos veces. overlayAbierto es un
// único estado (no dos booleanos) para que el drawer y la campana nunca puedan quedar abiertos
// a la vez.
export default function NavegacionMobile() {
    const location = useLocation();
    const { user, puede } = useAuth();
    const [overlayAbierto, setOverlayAbierto] = useState(null);

    const puedeAnses = puede('herramientas.expedientes');
    const sistema = useNotificacionesSistema();
    const whatsapp = useNotificacionesWhatsApp();
    const anses = useNotificacionesAnses(puedeAnses);
    const correo = useNotificacionesCorreo();

    const seccionesVisibles = getSeccionesVisibles(user, puede);
    const gruposVisibles = getGruposVisibles(seccionesVisibles);

    // Red de seguridad además del cierre explícito en cada click de navegación: si el overlay
    // quedara abierto por cualquier otro camino, un cambio de ruta lo cierra igual.
    useEffect(() => {
        setOverlayAbierto(null);
    }, [location.pathname]);

    const cerrarOverlay = () => setOverlayAbierto(null);
    const toggleDrawer = () => setOverlayAbierto((prev) => (prev === 'drawer' ? null : 'drawer'));
    const toggleCampana = () => setOverlayAbierto((prev) => (prev === 'campana' ? null : 'campana'));

    const totalNoLeidas = sistema.nuevasCount + whatsapp.totalNoLeidos + correo.noLeidosCount
        + (puedeAnses ? anses.nuevasCount : 0);

    return (
        <>
            <MobileHeader
                totalNoLeidas={totalNoLeidas}
                onAbrirCampana={toggleCampana}
                campanaAbierta={overlayAbierto === 'campana'}
            />
            <BottomNav
                seccionesVisibles={seccionesVisibles}
                gruposVisibles={gruposVisibles}
                overlayAbierto={overlayAbierto}
                onAbrirMenu={toggleDrawer}
            />
            {overlayAbierto === 'drawer' && (
                <DrawerMas seccionesVisibles={seccionesVisibles} onCerrar={cerrarOverlay} />
            )}
            {overlayAbierto === 'campana' && (
                <CampanaUnificada
                    sistema={sistema}
                    whatsapp={whatsapp}
                    anses={anses}
                    correo={correo}
                    puedeAnses={puedeAnses}
                    onCerrar={cerrarOverlay}
                />
            )}
        </>
    );
}
